export type CampoOrdenacaoMatriz = 'nome' | 'municipio' | 'total' | 'meses';
export type ModoValorMatriz = 'registros' | 'peso' | 'ambos';

interface LinhaOrdenavel {
  nome: string;
  municipioUf: string | null;
  mesesAtivos: number;
  total: { registros: number; kg: number };
}

// Mesma regra de ordenação do backend (ordenarLinhas): nome sem acento/caixa; município/UF (n/d por último,
// nos dois sentidos); total (kg em "peso", registros nos demais); meses ativos; empate pelo nome.
export const ordenarLinhas = <T extends LinhaOrdenavel>(linhas: T[], ordenar: CampoOrdenacaoMatriz, direcao: 'asc' | 'desc', modo: ModoValorMatriz): T[] => {
  const porNome = (a: T, b: T) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' });
  const chave = (l: T) => (ordenar === 'meses' ? l.mesesAtivos : modo === 'peso' ? l.total.kg : l.total.registros);
  const sinal = direcao === 'desc' ? -1 : 1;
  return [...linhas].sort((a, b) => {
    if (ordenar === 'nome') return sinal * porNome(a, b);
    if (ordenar === 'municipio') {
      if (!a.municipioUf !== !b.municipioUf) return a.municipioUf ? -1 : 1;
      const c = a.municipioUf && b.municipioUf ? a.municipioUf.localeCompare(b.municipioUf, 'pt-BR', { sensitivity: 'base' }) : 0;
      return c !== 0 ? sinal * c : porNome(a, b);
    }
    const d = chave(a) - chave(b);
    return d !== 0 ? sinal * d : porNome(a, b);
  });
};
